export const TYPE_CHOICES = [
  { value: 'awaiting_review', label: 'Awaiting review' },
  { value: 'rejected', label: 'Rejected' },
  { value: 'rollout_started', label: 'Automated rollout started (iOS)' },
  { value: 'rollout_paused', label: 'Rollout paused (provide %)' },
  {
    value: 'rollout_resumed',
    label: 'Automated rollout resumed (iOS - provide %)',
  },
  {
    value: 'rollout_increased',
    label: 'Rollout Increased (Android - provide %)',
  },
  { value: 'live', label: 'Live' },
] as const;
